<template>
  <div class="card-template">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.card-template {
  @include ds-card-surface;
}
</style>
